module.exports = __webpack_public_path__ + "img/bg_newsletter_form_embedded_v2.0608838.webp";